export const queueStatus = {
	NONE: 'none',
	IN_QUEUE: 'inQueue',
	ACCEPTED: 'accepted',
}
